import { ArrowRightRegular, DeveloperBoardRegular, DocumentTextRegular, PersonRegular, SettingsRegular } from '@fluentui/react-icons';
import type { Page } from '../workbench-shared';

export function PersonalPage({ customer, developerAllowed, onNavigate }: { customer: string; developerAllowed: boolean; onNavigate(page: Page): void }) {
  return <main className="personal-page">
    <header><span className="personal-avatar"><PersonRegular /></span><div><h1>{customer}</h1><p>账户与工作台</p></div></header>
    <div className="personal-actions">
      <button type="button" onClick={() => window.dispatchEvent(new Event('minglun:open-account'))}><PersonRegular /><span><strong>账户与设备</strong><small>登录安全、授权设备与数据额度</small></span><ArrowRightRegular /></button>
      {developerAllowed && <>
        <button type="button" onClick={() => onNavigate('global-settings')}><SettingsRegular /><span><strong>设置</strong><small>求解策略与默认数据</small></span><ArrowRightRegular /></button>
        <button type="button" onClick={() => onNavigate('characters')}><DeveloperBoardRegular /><span><strong>开发资料</strong><small>命轮与关系命轮</small></span><ArrowRightRegular /></button>
        <button type="button" onClick={() => onNavigate('logs')}><DocumentTextRegular /><span><strong>运行日志</strong><small>查看运行详情与错误信息</small></span><ArrowRightRegular /></button>
      </>}
    </div>
  </main>;
}
